// extracted by mini-css-extract-plugin
module.exports = {"titleSectionCheckbox":"checkboxInputFormProject_titleSectionCheckbox__3odkN","label":"checkboxInputFormProject_label__-WWk8","contentCheckbox":"checkboxInputFormProject_contentCheckbox__1nP6d","item":"checkboxInputFormProject_item__2-y6s","checkbox":"checkboxInputFormProject_checkbox__3zjY_"};
    if(module.hot) {
      // 1745223434204
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  